import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '../../../../common/text';
import { ChartRow, RowItem } from '../../ChartRowAndHeader.styles';

export const PersonsOffshoreChartRow = ({ data, ...props }) => (
    <ChartRow>
        <RowItem>
            <Text bold>{data.key}</Text>
        </RowItem>
    </ChartRow>
);

PersonsOffshoreChartRow.displayName = 'PersonsOffshoreChartRow';

PersonsOffshoreChartRow.propTypes = {
    data: PropTypes.object,
};
